import request from '@/utils/request'
/**
 *  查看投标文件
 * */

//标段列表
export const bidDocumentList = (data) => {
    return request.get('/api/agent/bidDocument/list?projectCode=' + data.projectCode + "&bidSectionName=" + data.bidSectionName + "&pageNum=" + data.pageNum + "&pageSize=" + data.pageSize + "&stage=" + data.stage)
}
//投标人列表
export const bidderList = (data) => {
    return request.get('/api/agent/bidDocument/bidderList?bidSectionCode=' + data.bidSectionCode + "&bidderName=" + data.bidderName + "&pageNum=" + data.pageNum + "&pageSize=" + data.pageSize)
}